import Vue from 'vue';
import {get, trimEnd} from 'lodash';
import {findKeyField} from "./utils";

/**
 * get the title of the model
 * @callback title
 * @this {Vue} vm
 * @param model
 * @param schema
 * @return {String}
 */
export function title(model, schema) {
  return get(model, 'id', 'default schema name');
}

/**
 * @callback columns
 * @this {Vue} table/form component
 * @param {null|Object} model the current model, or null if creating new
 * @param schema
 * @param {Boolean} readonly
 * @param {Boolean} table true if in table component
 * @return {Array.<Object>} fieldSpecs
 */
export function columns(model, schema, readonly, table) {
  return [
    {
      "label": "Member Id",
      "prop": "member_id",
      "type": "string"
    },
    {
      "label": "Email",
      "prop": "created_at",
      "type": "date"
    },
    {
      "label": "Basicinfo Fulfilled",
      "prop": "basicInfo_fulfilled",
      "type": "boolean"
    },
    {
      "label": "Gender",
      "prop": "details.profile.gender",
      "type": "string"
    },
  ];
}

/**
 * @callback list
 * @param {int} skip default 0
 * @param {int} limit default 20
 * @param {Array<{prop: String, desc: Boolean}>} sort column name
 * @param {String} search query
 * @param schema
 * @this {Vue} table component
 * @return {Promise<{total: Number, data: Array.<Object>}>}
 */

/**
 * fetch record by id
 * @callback read
 * @param id
 * @param schema
 * @this {Vue} form component
 * @return {Promise<Object>} model
 */

/**
 * optional handler, called when user click on table row and redirect to item details
 * @callback view
 * @this {Vue} table component
 * @param model
 * @param {int} index item index in table
 * @param schema
 * @param columns
 * @return {Promise.<void>}
 */
export function view(model, index, schema, columns) {
  let field = findKeyField(columns);
  if (field) {
    this.$router.push(trimEnd(this.$route.path, '/') + '/' + get(model, field.prop));
  }
  return Promise.resolve();
}

/**
 * optional handler, called when user click the create item button
 * @this {Vue} table component
 * @param schema
 * @param columns
 * @return {Promise.<void>}
 */
export function create(schema, columns) {
  this.$router.push(trimEnd(this.$route.path, '/') + '/create');
  return Promise.resolve();
}

/**
 * optional edit handler, called when user click on table row and redirect to edit form
 * @param model
 * @param {int} index item index in table
 * @param schema
 * @param columns
 * @this {Vue} table component
 * @return {Promise.<boolean>} return true in promise to refresh data
 */
export function edit(model, index, schema, columns) {
  let field = findKeyField(columns);
  if (field) {
    this.$router.push(trimEnd(this.$route.path, '/') + '/' + get(model, field.prop) + '?edit=');
  }
  return Promise.resolve(false);
}

/**
 * @this {Vue} form component
 * @param {null|Object} model the current model, or null if creating new
 * @param schema
 * @param {Boolean} readonly
 * @return {Array.<{
 *            label: String,
 *            class: String|Object|Array,
 *            validation: Boolean,
 *            action: Function<Promise<Boolean>>
 *         }>} button actions
 * <p>- action result resolves to TRUE will reload the form
 */
export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    temp.push({
      label: 'Update',
      class: 'btn-info',
      validation: true,
      action(model, schema, columns) {
        return Promise.resolve(false);
      }
    });
  }
  temp.push({
    label: 'Delete',
    class: 'btn-danger',
    validation: false,
    action(model, schema, columns) {
      return Promise.resolve(false);
    }
  });
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/sample.js